var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 960) scale(1, -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.214 439.676l-266.531 435.506c-6.264 10.235 1.102 23.378 13.101 23.378h757.76c12 0 19.365-13.143 13.101-23.378l-266.531-435.506v-432.325c0-12.047-13.237-19.405-23.469-13.045l-220.18 136.865c-4.509 2.803-7.251 7.736-7.251 13.045v295.46zM145.193 867.84l254.482-415.819c1.477-2.414 2.259-5.188 2.259-8.018v-291.249l189.46-117.769v409.018c0 2.83 0.782 5.604 2.259 8.018l254.482 415.819h-702.943z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.b9e9e4fc645fdfe6db29ba26851aa423.svg";
export { ForwardRef as ReactComponent };